<template>
  <!-- KOL推荐 -->
  <section id="kol" class="kol">
    <div class="l-center">
      <h2 class="title"></h2>
      <div ref="swiper" class="swiper kol-list">
        <ul class="swiper-wrapper">
          <li
            class="swiper-slide kol-item"
            :style="{ '--bg-image': `url(${item.tag})` }"
            v-for="(item, idx) of kolList"
            :key="idx"
          >
            <div class="kol-name" :title="item.name">
              <div class="kol-avatar">
                <img :src="item.avatar" alt="" />
              </div>
              <span class="kol-name__text text-ellipsis">{{ item.name }}</span>
            </div>
            <div class="kol-intro" :title="item.intro">
              <span>"{{ item.intro }}"</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div id="kol-slider" class="kol-slider">
            <div class="kol-slider__btn"></div>
          </div> -->
    </div>
    <div class="swiper-controller">
      <div ref="pagination" class="swiper-pagination"></div>
      <div ref="prev" class="swiper-button-prev"></div>
      <div ref="next" class="swiper-button-next"></div>
    </div>
    <div ref="fontScroll" class="kol-font-scroll">
      <div class="modal"></div>
      <div class="kol-font-scroll-text" @click="toJoinCivi">
        <div class="kol-font-scroll__inner ff--trajanpro-bold">
          <span v-for="(item, idx) of $locale.kol.propaganda" :key="idx">{{
            item
          }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import cfgData from "scripts/constants/configData";
import { Debounce } from "scripts/util";

function ani(fn) {
  let start = new Date().getTime();
  if (window.requestAnimationFrame) {
    function _run() {
      const now = new Date().getTime();
      fn(now - start);
      start = now;
      requestAnimationFrame(_run);
    }
    _run();
  } else {
    setInterval(() => {
      const now = new Date().getTime();
      fn(now - start);
      start = now;
    }, 16.7);
  }
}
export default {
  name: "KOL",
  data() {
    return {
      kolList: cfgData.kolList,
    };
  },
  created() {},
  mounted() {
    const mySwiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
      pagination: {
        el: this.$refs.pagination,
      },
    });

    // 文字滚动效果
    setTimeout(() => {
      this.fontScroll($(this.$refs.fontScroll).find(".kol-font-scroll__inner"));

      const fn = Debounce(() => {
        $(".kol-list .kol-intro").each((idx, el) => {
          const span = $(el).find("span");
          let isHeighter = span.height() > $(el).height() - 10;
          console.log("isHeighter", isHeighter);
          span.css({
            "align-self": isHeighter ? "flex-start" : "auto",
          });
        });
      });

      $(window).on("resize", fn);
      fn();
    }, 200);
  },
  computed: {},
  methods: {
    fontScroll(container) {
      // 文字滚动效果
      const textWrap = container;
      const textLen = textWrap.find("span").length;
      textWrap.append(textWrap.find("span").clone());
      const textList = textWrap.find("span");
      const wrapH = textWrap.height();
      const textH = textList.eq(0).outerHeight();
      const gap = 2 * textH;
      textList.each((idx, text) => {
        console.log(text);
        let top = text.offsetTop;
        $(text).css({
          opacity: (wrapH - top) / wrapH,
          top: textH * idx + Math.floor(idx / textLen) * gap,
        });
      });
      let step = 0;
      ani((duration) => {
        step += duration / 20;
        if (step >= 1) {
          textList.each((_, text) => {
            let top = text.offsetTop;
            $(text).css({
              opacity: (wrapH - top) / wrapH,
              top:
                top <= -1 * textH - gap
                  ? textH * (textList.length - 1) + gap
                  : top - 1,
            });
          });
          step = 0;
        }
      });
    },
    // 去加入文明
    toJoinCivi() {
      $("html")
        .stop()
        .animate({
          scrollTop: $("#join").get(0).offsetTop - $("#header").height(),
        });
    },
  },
};
</script>

<style lang="less">
.kol {
  position: relative;
  display: flex;
  justify-content: center;
  height: 1148px;

  .l-center {
  }

  .title {
    margin: 20px 0 40px;
    height: 97px;
    background: url(~images/title/kol.png) no-repeat 0 center;
    background-size: 100% auto;
  }

  &-list {
    width: 1125px;
    height: 361px;
  }

  .swiper-wrapper {
    height: 100%;
  }

  .swiper-controller {
    position: absolute;
    width: auto;
    top: 534px;
    display: flex;
    align-items: center;
    padding: 0 82px;
    z-index: 2;
  }

  .swiper-button-prev {
    left: 0;
    width: 22px;
    height: 34px;
    background: url(~images/join/btn_prev.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .swiper-button-next {
    right: 0;
    width: 22px;
    height: 34px;
    background: url(~images/join/btn_next.png) no-repeat 0 center;
    background-size: 100% 100%;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    content: none;
  }

  .swiper-button-prev,
  .swiper-button-next {
    // top: auto;
    margin-top: -20px;
    z-index: 11;
  }

  .swiper-pagination-bullets {
    @bullet-size: 8px;
    @border-width: 1px;

    position: static;
    flex: 1;
    // display: flex;
    // justify-content: center;

    .swiper-pagination-bullet {
      width: @bullet-size;
      height: @bullet-size;
      margin: 0 2px;
      background-color: #fff;
      border: @border-width solid #493f31;
      opacity: 1;

      &-active {
        margin: 0 4px;
        width: 98px;
        border-radius: (@bullet-size / 2);
        background-color: #f8b22c;
        border: (@border-width / 2) solid #493f31;
      }
    }
  }

  &-item {
    position: relative;
    width: 347px + 28px;
    padding: 0 14px;
    background: url(~images/kol/box_bg.png) no-repeat 0 0;
    background-size: 100% 100%;

    &::after {
      position: absolute;
      top: 14px;
      right: 40px;
      content: "";
      width: 60px;
      height: 40px;
      background: var(--bg-image) no-repeat 0 0;
      background-size: 100% 100%;
    }

    // &:nth-child(3n + 1)::after {
    //   background-image: url(~images/kol/tag/blue.png);
    // }

    // &:nth-child(3n + 2)::after {
    //   background-image: url(~images/kol/tag/red.png);
    // }

    // &:nth-child(3n + 3)::after {
    //   background-image: url(~images/kol/tag/orange.png);
    // }
  }

  &-name {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 30px 25px 10px;

    &__text {
      position: relative;
      top: 2px;
      left: 2px;
      width: 182px;
      height: 32px;
      margin-left: 10px;
      padding: 0 10px;
      font-size: 16px;
      line-height: 32px;
      color: var(--primary-color);
      background: #ae8e66;
      border-radius: 16px;
    }
  }

  &-avatar {
    width: 101px;
    height: 101px;
    padding: 8px 10px 10px;
    background: url(~images/kol/avatar_bg.png) no-repeat 0 0;
    background-size: contain;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  &-intro {
    @color: #ae8e66;
    position: relative;
    display: flex;
    align-items: center;
    height: 186px;
    margin: -5px 18px 0;
    padding: 10px;
    font-size: 16px;
    line-height: 24px;
    color: #553c28;
    background-color: #f3f0e8;
    border-radius: 8px;
    border: 3px solid @color;
    box-shadow: 0 -4px 4px fadeout(@color, 20%) inset;
    overflow: hidden auto;

    span {
      // background-color: antiquewhite;
      // animation: translateY linear infinite;
    }

    @keyframes translateY {
      from {
        transform: translateY(50px);
      }
      to {
        transform: translateY(-100%);
      }
    }
  }

  &-slider {
    position: relative;
    width: 454px;
    height: 10px;
    margin: 36px auto 0;
    background-color: antiquewhite;
    border-radius: 5px;
    border: 1px solid #333;
    z-index: 2;

    &__btn {
      position: absolute;
      top: -1px;
      left: 0;
      height: 10px;
      // cursor: grab;

      &::after {
        content: "";
        position: absolute;
        top: 3px;
        left: 2px;
        right: 2px;
        height: 4px;
        background-color: #ff9900;
        border-radius: 2px;
      }
    }
  }

  .kol-font-scroll {
    position: absolute;
    bottom: 600px;
    left: 34px;
    display: flex;
    align-items: center;
    // width: 1447px;
    // height: 670px;
    // width: 1002px;
    // height: 259px;
    margin: 0 auto;
    // overflow: hidden;
    color: white;
    z-index: 1;

    .modal {
      position: absolute;
      top: 0;
      left: -20px;
      width: 851px;
      height: 670px;
      background: url(~images/kol/modal.png) no-repeat 0 0;
      background-size: 100% 100%;
      z-index: 1;
    }

    &-text {
      position: absolute;
      top: 275px;
      left: 451px;
      width: 1002px;
      height: 259px;
      background: url(~images/kol/box_bg_3.png) no-repeat 0 0;
      background-size: 100% 100%;
      cursor: pointer;
    }

    &__inner {
      position: absolute;
      top: 48px;
      right: 40px;
      display: flex;
      flex-direction: column;
      width: 700px;
      height: 144px;
      font-size: 24px;
      color: var(--primary-color);
      text-shadow: 1px 2px 0px rgba(57, 46, 32, 0.54),
        0px 0px 1px rgba(255, 233, 129, 0.69);
      overflow: hidden;
    }

    span {
      user-select: none;
      position: absolute;
      padding: 4px 0;
      flex-shrink: 0;
      width: 100%;
      opacity: 0;
      white-space: nowrap;
    }
  }
}
</style>
